import React from 'react'
import styled from 'styled-components'

const ContainerWrapper = styled.div`
  margin-top: 65px;
  padding: 1rem 2rem;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 1.5rem .8rem;
  `}
`

interface GlobalContainer {
  children: React.ReactNode
  style?: object
}

function Container(props: GlobalContainer): JSX.Element {
  const { children } = props

  return <ContainerWrapper {...props}>{children}</ContainerWrapper>
}

export default Container
